module.exports = __webpack_public_path__ + "static/media/blue-tip.86540101.svg";